"use client";

import React from "react";
import { IamUser, TenantDetailsByTenantIdRow } from "@guberno/data-access";

interface AppContextproviderProps {
  children: React.ReactChild | React.ReactFragment | React.ReactPortal | boolean | null | undefined;
  userData?: IamUser;
  appVersion?: string;
  appName?: string;
  //menuItems?: MenuItem[];
  tenantCompanyDetails?: TenantDetailsByTenantIdRow;
}

interface AppContextState {
  userData?: IamUser;
  enabledFeatures?: string[];
  appVersion?: string;
  //menuItems?: MenuItem[];
  tenantCompanyDetails?: TenantDetailsByTenantIdRow;
}

export interface ContextState {
  localAppState: AppContextState;
  setLocalAppState: React.Dispatch<React.SetStateAction<AppContextState>>;
  localAppName: string;
  localIsDrawerExpandedState: boolean;
  handleSetLocalIsDrawerExpandedState: (newState: boolean) => void;
}
export const AppContext = React.createContext<ContextState>({
  localAppState: {},
  localAppName: "",
  setLocalAppState: () => null,
  localIsDrawerExpandedState: true,
  handleSetLocalIsDrawerExpandedState: () => {},
});

export const AppContextProvider = (props: AppContextproviderProps) => {
  const { userData, tenantCompanyDetails, appVersion, appName } = props;
  const [localAppName] = React.useState<string>(appName);

  const [localAppState, setLocalAppState] = React.useState<AppContextState>({
    userData: userData,
    tenantCompanyDetails: tenantCompanyDetails,
    appVersion: appVersion,
  });

  const [localIsDrawerExpandedState, setLocalIsDrawerExpandedState] = React.useState<boolean>(() => {
    if (typeof window !== "undefined") {
      const savedState = window.localStorage.getItem("FlatDrawer");
      if (savedState) {
        return JSON.parse(savedState).isDrawerExpanded;
      }
    }
    return true; // Default to true if no saved state
  });

  React.useEffect(() => {
    if (window && window.localStorage.getItem("FlatDrawer")) {
      const getFilterItem = JSON.parse(window.localStorage.getItem("FlatDrawer"));

      if (getFilterItem) {
        setLocalIsDrawerExpandedState(getFilterItem.isDrawerExpanded);
      } else {
        localStorage.setItem("FlatDrawer", JSON.stringify({ isDrawerExpanded: true }));
        setLocalIsDrawerExpandedState(true);
      }
    }
  }, []);

  const handleSetLocalIsDrawerExpandedState = (newState: boolean) => {
    setLocalIsDrawerExpandedState(newState);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("FlatDrawer", JSON.stringify({ isDrawerExpanded: newState }));
    }
  };

  const context: ContextState = {
    localAppName,
    localAppState,
    setLocalAppState,
    localIsDrawerExpandedState,
    handleSetLocalIsDrawerExpandedState,
  };
  return <AppContext.Provider value={context}>{props.children}</AppContext.Provider>;
};
export default AppContextProvider;
